import CouponError from './CouponsError';
class InvalidCouponStatus extends CouponError {
    couponId;
    propertyId;
    constructor(couponId, propertyId, options) {
        super('Invalid promotional coupon status', options);
        this.couponId = couponId;
        this.propertyId = propertyId;
    }
}
export default InvalidCouponStatus;
